<div class="container">
    <div class="title">
        {{ data.isEditing ? ('ceu-unit.dialog.title.edit' | translate) : ('ceu-unit.dialog.title.create' | translate) }}
    </div>
    <div class="content-container">
        <div class="input-container">
            <div class="input-title">
                {{ 'ceu-unit.dialog.type' | translate }}
            </div>
            <app-simple-dropdown
                style="height: 56px"
                [options]="TYPE_OPTIONS"
                [selectedOption]="type"
                (onOptionSelected)="handleTypeChanged($event)">
            </app-simple-dropdown>
        </div>

        <!-- <div class="input-container">
            <div class="input-title">
                {{ 'ceu-unit.dialog.location' | translate }}
            </div>
            <app-channel-text-input
                [name]="Location_Input"
                label="ceu-unit.dialog.location"
                [value]="location"
                (onInputChange)="onLocationChange($event)"
                (onFocusChange)="onLocationChange($event)"
                [inputError]="validationErrors?.location">
            </app-channel-text-input>
        </div> -->

        <div class="input-container">
            <div class="input-title">
                {{ 'ceu-unit.dialog.ip-a' | translate }}
            </div>
            <app-channel-text-input
                [name]="Line_A_Input"
                [placeholder]="'ceu-unit.dialog.ip-a'"
                [value]="lineA"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [inputError]="validationErrors?.lineAIp">
            </app-channel-text-input>
        </div>

        <div class="input-container">
            <div class="input-title">
                {{ 'ceu-unit.dialog.ip-b' | translate }}
            </div>
            <app-channel-text-input
                [name]="Line_B_Input"
                [placeholder]="'ceu-unit.dialog.ip-b'"
                [value]="lineB"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [inputError]="validationErrors?.lineBIp">
            </app-channel-text-input>
        </div>
    </div>
    <div class="footer">
        <div class="text-button" (click)="closeDialog()">
            {{ 'dlg.cancel' | translate }}
        </div>
        <div class="text-button save-button" (click)="save()" [class.save-disable]="isSaveDisabled">
            {{ data.isEditing ? ('dlg.edit' | translate) : ('dlg.create' | translate) }}
        </div>
    </div>
</div>
